import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PackageService {
  readonly name = 'aramis-process-center';
  readonly version = '0.12.0';
  readonly description = '';
  readonly displayName = 'Process Center';
}
